import "./tooltip.scss";
export default function Tooltip({ tip}) {
  return (
    <div className="tooltip flex align-center">
        <div className="tip">{tip}</div>
    </div>
  );
}
